import React, { } from "react";
import Chart from "react-apexcharts";

const ApexChart = React.forwardRef(({
    series = [{
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91]
    }],
    options = {},
    style = {},
    height = "100%",
    width = "100%",
    id = "basic-bar",
    type = "bar"
}, ref) => {
    const optionsDefault = {
        chart: {
            id
        },
        xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        },
        ...options
    };

    return (
        <div
            ref={ref}
            className="bar-chart"
            style={{
                height: "97%", width: "100%", position: "relative", ...style
            }}
        >
            <Chart
                options={optionsDefault}
                series={series}
                type={type}
                height={height}
                width={width}
            />
        </div>
    );
});

export default ApexChart;
